import { useEffect, useState } from "react";
import { useConfig } from "../../hooks/useConfig";
import { formatDateTime, formatTimeLeft } from "../../lib/format";

const PHASE_COPY = {
  registration: "Registration is open",
  claim: "Claims are open",
  closed: "The airdrop is closed",
} as const;

export function PhaseBanner() {
  const { config } = useConfig();
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 30_000);
    return () => window.clearInterval(id);
  }, []);

  if (!config) return null;
  const closesAt = config.registrationClosesAt;

  return (
    <div className="stack stack-2">
      <span className={config.phase === "closed" ? "badge" : "badge badge--live"}>
        {PHASE_COPY[config.phase]}
      </span>
      {config.phase === "registration" && closesAt !== null ? (
        <p className="small">
          Registration closes {formatDateTime(closesAt)}. {formatTimeLeft(closesAt, now)}.
        </p>
      ) : null}
    </div>
  );
}
